<template lang="pug">
    #app(:class="{mobile: isMobileDevice}")
        Header
        router-view
        .orientationChange
            img(src="@/assets/img/orientation_change.gif" alt="")
            h3 Поверните телефон
</template>

<script>
    import Header from '@/components/app/Header'

    export default {
        computed: {
            isMobileDevice() {
                return this.$store.state.isMobileDevice;
            },
        },
        components: {
            Header,
        },
        created() {
            this.$store.commit('checkMobile');
        },
        mounted() {
            if (this.isMobileDevice) {
                document.querySelector('#app').style.height = window.innerHeight + 'px'
                window.addEventListener('resize', () => {
                    document.querySelector('#app').style.height = window.innerHeight + 'px'
                })
                window.addEventListener('orientationchange', ()=>{
                    if (screen.orientation.angle === 0){
                        location.reload();
                    }
                })
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "@/assets/scss/_mixins.scss";

    .orientationChange {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000000;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 4vh;
        background: url(assets/img/orientation_change_bg.jpg) no-repeat left top / cover;

        img {
            height: 44vh;
        }
        h3{
            font-size: 4.5vh;
            letter-spacing: 0.05vh;
            color: #fff;
        }
    }

    .mobile {
        @include landscape {
            .orientationChange {
                display: flex;
            }
        }
    }
</style>
